import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheck, FiArrowRight, FiShield, FiLock, FiCreditCard, FiUser, FiZap, FiCalendar } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import SchedulingForm from './SchedulingForm';

const CheckoutPage = () => {
  const [step, setStep] = useState(1);
  const whatsappNumber = "+529844594738";

  return (
    <div className="min-h-screen bg-zinc-950 pt-32 pb-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-yellow-500/20 text-yellow-500 px-4 py-1 rounded-full text-[10px] font-black uppercase tracking-widest mb-4 border border-yellow-500/30">
            <SafeIcon icon={FiShield} /> Secure Enrollment Process
          </div>
          <h1 className="text-4xl font-black text-white uppercase">Inicia tu <span className="text-red-500">Inscripción</span></h1>
        </div>

        <div className="grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-12">
            <div className="bg-zinc-900 border border-zinc-800 rounded-[2.5rem] p-8 shadow-2xl relative overflow-hidden">
              {/* Progress Bar */}
              <div className="flex justify-between mb-8 max-w-md mx-auto">
                {[1, 2, 3].map((s) => (
                  <div key={s} className="flex flex-col items-center gap-2">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center font-black text-sm border-2 transition-all ${step >= s ? 'bg-green-600 border-green-500 text-white' : 'bg-black border-zinc-700 text-gray-500'}`}>
                      {step > s ? <SafeIcon icon={FiCheck} /> : s}
                    </div>
                    <span className={`text-[10px] font-black uppercase tracking-widest ${step >= s ? 'text-white' : 'text-gray-600'}`}>
                      {s === 1 ? 'Cuenta' : s === 2 ? 'Pago' : 'Agenda'}
                    </span>
                  </div>
                ))}
              </div>

              <AnimatePresence mode="wait">
                {step === 1 && (
                  <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} className="space-y-6 max-w-xl mx-auto">
                    <h3 className="text-xl font-black text-white uppercase text-center">Datos del Estudiante</h3>
                    <div className="space-y-4">
                      <div className="grid grid-cols-2 gap-4">
                        <input type="text" placeholder="Nombre" className="bg-black border border-zinc-800 p-4 rounded-2xl text-white focus:border-green-500 outline-none" />
                        <input type="text" placeholder="Apellido" className="bg-black border border-zinc-800 p-4 rounded-2xl text-white focus:border-green-500 outline-none" />
                      </div>
                      <input type="email" placeholder="Correo Electrónico" className="w-full bg-black border border-zinc-800 p-4 rounded-2xl text-white focus:border-green-500 outline-none" />
                    </div>
                    <button onClick={() => setStep(2)} className="w-full bg-green-600 text-white py-5 rounded-2xl font-black uppercase tracking-widest hover:bg-green-500 transition-all flex items-center justify-center gap-2">
                      Siguiente Paso <FiArrowRight />
                    </button>
                  </motion.div>
                )}

                {step === 2 && (
                  <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} className="space-y-8 max-w-xl mx-auto text-center">
                    <h3 className="text-xl font-black text-white uppercase">Realiza tu Pago</h3>
                    <div className="bg-black/50 p-8 rounded-3xl border border-zinc-800">
                      <p className="text-gray-400 mb-6 font-medium">Una vez completado el pago, podrás agendar tus horarios en el siguiente paso.</p>
                      <div className="grid gap-4">
                        <a href="https://buy.stripe.com/4gM5kw2qMcmr1eCcEtc3m0h" target="_blank" rel="noreferrer" className="bg-indigo-600 text-white py-5 rounded-2xl font-black uppercase text-sm flex items-center justify-center gap-3 hover:bg-indigo-500 transition-all">
                          <SafeIcon icon={FiCreditCard} /> Pagar con Tarjeta
                        </a>
                        <a href={`https://wa.me/${whatsappNumber.replace('+','')}`} target="_blank" rel="noreferrer" className="bg-green-600 text-white py-4 rounded-2xl font-black uppercase text-xs flex items-center justify-center gap-2 hover:bg-green-500 transition-all">
                          <SafeIcon icon={FaWhatsapp} /> Pago Manual / WhatsApp
                        </a>
                      </div>
                    </div>
                    <button onClick={() => setStep(3)} className="text-yellow-500 font-black uppercase text-xs tracking-widest hover:text-white transition-colors flex items-center gap-2 mx-auto">
                      Ya realicé mi pago, ir a agendar <FiArrowRight />
                    </button>
                  </motion.div>
                )}

                {step === 3 && (
                  <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="space-y-6">
                    <SchedulingForm />
                    <div className="text-center">
                      <button onClick={() => setStep(2)} className="text-gray-500 font-bold uppercase text-[10px] hover:text-white transition-colors">Volver a opciones de pago</button>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;